export default "__VITE_ASSET__OfvfwKH0__"